import contacts from './contacts'
import payment from './payment'

export default {

    contacts,
    payment,
    authenticatedAs: "Angemeldet als",

    booking: "Buchung",
    caution: "Achtung",
    previewActive: "Sie sehen diese Buchung im Vorschaumodus. Die Buchung ist möglicherweise noch nicht freigeschaltet.",
    next: "Weiter",
    bookNowPayable: "Jetzt zahlungspflichtig buchen",
    bookNow: "Jetzt buchen",
    buyNow: "Jetzt zahlungspflichtig bestellen",
    orderNow: "Jetzt bestellen",
    someErrors: "Etwas stimmt noch nicht!",
    someErrorsExplanation: "Bitte korrigieren Sie folgende Felder:",
    done: "Fertig",
    someErrorsExplanationRegStepPage: "Bevor Sie zum nächsten Schritt gehen können, müssen Sie noch folgende Fehler korrigieren:",
    clickExplanation: "(Ein Klick auf eine der Schaltfächen, führt Sie zu dem fehlerhaften Feld)",

    isRequested: "Offene Buchungsanfrage",

    bookingSuccessful: "Ihre Buchungsanfrage wurde erfolgreich an uns übermittelt.",
    yourBookingNumber: "Ihre Buchungsnummer lautet",

    openPrintView: "Druckansicht Ihrer Buchung öffnen",
    loadingDocument: "Ihr Dokument wird geladen",
    eventPrintView: "Druckansicht Ihrer Veranstaltung",
    eventPreContractualInfo: "Vorvertragliche Informationen Ihrer Veranstaltung",
    from: "von",
    to: "bis",
    useTime: 'Verwende Uhrzeiten',
    daysInclusive: 'Anfangs- und Endtag einschließlich',
    title: "Bezeichnung",
    contactPerson: "Kontaktperson",
    firstName: "Vorname",
    lastName: "Nachname",
    email: "E-Mail",
    note: "Anmerkung",
    period: "Zeitraum",
    resource: "Ressource",
    numberOfPersons: "Anzahl Personen",

    bookingNumber: "Buchungsnummer",

    requestFormHeader: "Buchung '{title}', {start} - {end}",
    finished: "Fertig",
    addBooking: "Buchung hinzufügen",
    remove: "Buchung löschen",
    nextStep: "Weiter",

    requestBooking: "Ressourcenbuchung beantragen",
    notBooked: "Buchung konnte nicht beantragt werden.",

    salutation: "Anrede",

    book: "Buchen",
    dismiss: "Verwerfen",

    yourAnswer: "Ihre Antwort",
    answerFrom: "Antwort zu",
    yourDateAnswer: "Datum angeben",
    dateAnswerFrom: "Datumangabe von",

    comments: "Anmerkungen",
    detailsAbout: "Details zu",

    test: "Test Validation",
    internalSite: "Interne Buchungsseite",
    internalSiteInfo: "Diese Buchung wird auf einer internen Seite durchgeführt. Sie können nur Buchungen vornehmen, " +
        "wenn Sie als interner Benutzer angemeldet sind.",
    login: "Anmeldung",
    loginEmail: "Login E-Mail",
    password: "Passwort",
    signIn: "Anmelden",

    loginInfo: "Sie können sich hier mit Ihren amosWEB Logindaten anmelden. Für andere Login-Optionen, melden Sie " +
        "sich bitte über die reguläre ",
    loginInfoSecond: " an. Laden Sie dann nach erfolgreicher Anmeldung diese Seite bitte neu.",
    twoFactorInfo: "Dieser Account erfordert ein 2FA generiertes Passwort. Bitte geben Sie dieses unten ein.",


    twoFactor: {
        enterTotp: "Für diesen Account wurde die Zweistufige Authentifizierung aktiviert. Bitte geben Sie" +
            " einen gültigen Code von Ihrem aktivierten Gerät ein.",
        login: "Bestätigen",
        code: "Authentifizierungscode",
        recoveryCode: "Wiederherstellungscode",
        tooManyAttempts: "Zu viele falsche Authentifizierungscodes gesendet!",
        wrongCode: "Der eingegebene Code war nicht gültig!"
    }

}
